import { render } from "./Calculation-2024.vue?vue&type=template&id=2e1d648a"
import script from "./Calculation-2024.vue?vue&type=script&lang=js"
export * from "./Calculation-2024.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__